import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Modal, Select, Button, Input, Icon, DatePicker, Checkbox } from 'antd'
import TextArea from 'antd/es/input/TextArea'
import { commissions } from '@services/api'
import moment from 'moment'
import { titles } from '@pages/GeneralRequest/Utils/settings'
import {
    input_element,
    editPopupFirstRow,
    editPopupSecondRow,
    editPopupSums,
    unsetMargin,
    container,
    editPopupSelectRow,
    selectProduct,
    calendarBug
} from '@pages/AgentCommissions/Reports/style.scss'
import { subNames, isNumber } from '@utils/index'

@inject((store: any) => {
    const { popupStore, authStore } = store
    return { popupStore, authStore }
})
@observer
export default class PaymentPopup extends Component<any, any> {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            //
            agent_name: null,
            agent_id: null,
            agent_search_id: null,
            //
            client_name: null,
            client_id: null,
            client_search_id: null,
            //
            mentor: null,
            //
            heb_class: null,
            product_title: null,
            sub_name: null,
            subscription_id: null,
            products: [],
            //
            price: null,
            commission: null,
            //
            report_date: null,
            paid_at: null,
            //
            comment: null,
            isOneTime: false
        }
    }

    componentDidMount(): void {}

    closePopup = reload => {
        const {
            popupStore: { togglePopup },
            events
        } = this.props
        events.setState({ createData: false }, () => {
            if (typeof reload === 'boolean') events.getCommissionRows(events.state.current, true)
            togglePopup('')
        })
    }

    onUserSearch = (e, searchId, keyName, keyId, isAgent, keyMentor) => {
        this.setState({ [searchId]: e.value.replace(/[^0-9]/g, '') }, () => {
            if (!this.state[searchId]) this.setState({ [keyName]: null, [keyMentor]: null })
            if (this.state[searchId] && e.value.replace(/[^0-9]/g, ''))
                commissions
                    .findUserForCommission({ id: this.state[searchId], isAgent })
                    .then(({ data, status }) => {
                        if (status === 201) return this.setState({ [keyName]: data.name, [keyId]: null })
                        if (status === 200)
                            this.setState({ [keyName]: data.name, [keyId]: data.id, [keyMentor]: data.mentor })
                    })
                    .catch(() => alert('אירעה שגיאה'))
        })
    }
    handleMentorSelect = (selectedMentor: string) => this.setState({ mentor: selectedMentor })
    onProductSelect = (data: string) => {
        const { product_name, heb_class, products } = JSON.parse(data)
        this.setState({ products, heb_class, product_title: product_name, sub_name: null, subscription_id: null })
    }
    onSubscriptionSelect = (data: string) => {
        const { subscription_id, name, price } = JSON.parse(data)
        this.setState({ sub_name: name, subscription_id, price })
    }

    onTextArea = (event, key) => this.setState({ [key]: event.value })
    onDateEvent = (date, dateString, key) => {
        this.setState({ [key]: moment(dateString).format('YYYY-MM-DD') })
    }
    onCheckboxChange = (event, key) => {
        this.setState({ isOneTime: event.target.checked })
        console.log(moment(new Date()).format('YYYY-MM-DD'))
        if (event.target.checked) {
            this.setState({
                products: [],
                heb_class: null,
                product_title: null,
                sub_name: 'עמלה חד פעמית',
                subscription_id: null,
                price: 0,
                paid_at: moment(new Date()).format('YYYY-MM-DD')
            })
        } else {
            this.setState({
                products: [],
                heb_class: null,
                product_title: null,
                sub_name: null,
                subscription_id: null,
                price: null,
                paid_at: null
            })
        }
    }

    createCommission = () => {
        this.setState({ loading: true })
        commissions
            .createCommissionRow(this.state)
            .then(res => {
                this.closePopup(true)
            })
            .catch(() => alert('אירעה שגיאה'))
    }

    render() {
        const {
            popupStore: { popupType },
            events
        } = this.props
        // prettier-ignore
        const {
            product_title, price, report_date, paid_at, commission, sub_name, products, loading, agent_name,
            agent_search_id, agent_id, client_id, client_name, client_search_id, mentor, comment, isOneTime
        } = this.state
        // prettier-ignore
        const {
            closePopup, onCheckboxChange, onDateEvent, onSubscriptionSelect, createCommission, onUserSearch, handleMentorSelect, onProductSelect, onTextArea
        } = this
        const {
            onNumberInput,
            state: { mentors, productList }
        } = events
        const btnInner = loading ? <Icon type="loading" /> : titles.confirm
        // prettier-ignore
        const isSubmit = isOneTime ? !( agent_id && isNumber(price) && isNumber(commission) && report_date && paid_at && mentor && client_id && comment) : !( agent_id && price !== null && commission && report_date && paid_at && sub_name && mentor && client_id )

        return (
            <Modal
                title={`יצירת עמלה`}
                visible={popupType === 'createCommissionRowPopup'}
                onCancel={closePopup}
                footer={null}
            >
                <div className={container}>
                    <div className={editPopupSecondRow} style={{ width: '115px' }}>
                        <div>עמלה חד פעמית</div>
                        <Checkbox onChange={onCheckboxChange} />
                    </div>
                    {/* search agent/client line */}
                    <div className={editPopupSecondRow} style={{ width: '100%' }}>
                        <div className={editPopupSums}>
                            <div>מזהה סוכן</div>
                            <Input
                                className={`${input_element} ${unsetMargin}`}
                                value={agent_search_id}
                                onInput={({ target }) =>
                                    onUserSearch(target, 'agent_search_id', 'agent_name', 'agent_id', true, 'mentor')
                                }
                            />
                        </div>
                        {agent_id ? <Icon type={'check'} style={{ color: 'green', marginTop: '20px' }} /> : null}
                        <div className={editPopupSums}>
                            <div>שם סוכן</div>
                            <Input
                                placeholder={agent_name}
                                style={{ width: '290px' }}
                                className={`${input_element} ${unsetMargin}`}
                                disabled={true}
                            />
                        </div>
                    </div>
                    {/* search agent/client line */}
                    <div className={editPopupSecondRow} style={{ width: '100%' }}>
                        <div className={editPopupSums}>
                            <div>מזהה לקוח</div>
                            <Input
                                className={`${input_element} ${unsetMargin}`}
                                value={client_search_id}
                                onInput={({ target }) =>
                                    onUserSearch(target, 'client_search_id', 'client_name', 'client_id', null, '')
                                }
                            />
                        </div>
                        {client_id ? <Icon type={'check'} style={{ color: 'green', marginTop: '20px' }} /> : null}
                        <div className={editPopupSums}>
                            <div>שם לקוח</div>
                            <Input
                                placeholder={client_name}
                                style={{ width: '290px' }}
                                className={`${input_element} ${unsetMargin}`}
                                disabled={true}
                            />
                        </div>
                    </div>
                    {/* chose mentor line */}
                    <div className={editPopupSelectRow}>
                        <div>
                            <div>{'בחירת מנטור'}</div>
                            <Select
                                value={mentor || 'בחרו מנטור'}
                                onChange={handleMentorSelect}
                                className={`${input_element} ${unsetMargin}`}
                                style={{ marginRight: 'unset', width: '160px' }}
                            >
                                {mentors.length &&
                                    mentors.map(({ name }) => (
                                        <Select.Option key={name} value={name}>
                                            {name}
                                        </Select.Option>
                                    ))}
                            </Select>
                        </div>
                        <div>
                            <div>{'בחירת מוצר'}</div>
                            <Select
                                value={subNames[product_title] || 'בחרו מוצר'}
                                onChange={onProductSelect}
                                className={`${input_element} ${unsetMargin} ${selectProduct}`}
                                style={{ marginRight: 'unset', width: '280px' }}
                                disabled={isOneTime}
                            >
                                {productList.map(item => (
                                    <Select.Option key={item.product_name} value={JSON.stringify(item)}>
                                        {subNames[item.product_name] || item.product_name}
                                    </Select.Option>
                                ))}
                            </Select>
                        </div>
                    </div>
                    {/* product subscription line */}
                    <div className={editPopupSelectRow}>
                        <div>{isOneTime ? 'סוג עמלה' : 'בחירת מנוי'}</div>
                        <Select
                            value={sub_name || 'בחרו מנוי'}
                            onChange={onSubscriptionSelect}
                            className={`${input_element} ${unsetMargin}`}
                            disabled={!!!product_title}
                            style={{ marginRight: 'unset', direction: 'rtl', width: '100%' }}
                        >
                            {products.length &&
                                products.map(item => (
                                    <Select.Option key={item.subscription_id} value={JSON.stringify(item)}>
                                        {item.name}
                                    </Select.Option>
                                ))}
                        </Select>
                    </div>
                    {/* sums commission line */}
                    <div className={editPopupFirstRow}>
                        <div className={editPopupSums}>
                            <div>{'עלות'}</div>
                            <Input
                                className={`${input_element} ${unsetMargin}`}
                                value={price}
                                onInput={({ target }) => onNumberInput(target, 'price', this, /[^0-9\.-]/g)}
                                disabled={isOneTime}
                            />
                        </div>
                        <div className={editPopupSums}>
                            <div>{'שנתי'}</div>
                            <Input
                                placeholder={isNumber(price) ? price * 12 : ''}
                                className={`${input_element} ${unsetMargin}`}
                                disabled={true}
                            />
                        </div>
                        <div className={editPopupSums}>
                            <div>{'עמלה'}</div>
                            <Input
                                className={`${input_element} ${unsetMargin}`}
                                value={commission}
                                onInput={({ target }) => onNumberInput(target, 'commission', this, /[^0-9\.-]/g)}
                            />
                        </div>
                    </div>
                    {/* dates commission line */}
                    <div className={editPopupFirstRow} style={{ margin: '10px 0' }}>
                        <div className={editPopupSums}>
                            <div>תאריך דו"ח</div>
                            <DatePicker.MonthPicker
                                placeholder={'בחרו תאריך'}
                                style={{ border: 'unset' }}
                                className={calendarBug}
                                onChange={(date, dateString) => onDateEvent(date, dateString, 'report_date')}
                                disabledDate={current => current && current > moment().endOf('day')}
                            />
                        </div>
                        <div className={editPopupSums}>
                            <div>{isOneTime ? 'תאריך יצירה' : 'תאריך רכישה'}</div>
                            <DatePicker
                                className={calendarBug}
                                placeholder={paid_at ? paid_at : 'בחרו תאריך'}
                                style={{ border: 'unset' }}
                                onChange={(date, dateString) => onDateEvent(date, dateString, 'paid_at')}
                                disabledDate={current => current && current > moment().endOf('day')}
                            />
                        </div>
                    </div>
                    {/* commission comment line */}
                    <div>
                        <div>הערה</div>
                        <TextArea rows={2} value={comment} onInput={({ target }) => onTextArea(target, 'comment')} />
                    </div>
                    {/* save/cancel commission btn line */}
                    <div style={{ marginTop: '20px' }}>
                        <Button disabled={isSubmit} type="primary" onClick={createCommission}>
                            {btnInner}
                        </Button>
                        <Button onClick={closePopup}>ביטול</Button>
                    </div>
                </div>
            </Modal>
        )
    }
}
